module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Bitcoin-0c79889563ab151686352ca2bc9589c3.svg";